<template>
    <b-modal :title="uLang('app.enrolled_candidates')" :ok-only="true" :ok-title="uLang('app.close')" ref="modal" @hidden="onHidden()" class="relative">
        <rea-loader :loading="isLoading"></rea-loader>
        <div class="row">
            <div class="col-12" v-if="enrolments.length" v-for="enrolment in enrolments">
                <div class="row relation-card">
                    <div class="col-3 relation-profile-photo">
                        <!-- ToDo: replace with link to actual user profile picture -->
                        <img class="img-fluid rounded-circle" :src="'https://picsum.photos/300?image=' + enrolment.id" :alt="uLang('app.relation_s_profile_photo', {relation: enrolment.relation.full_name})">
                    </div>
                    <div class="col-9">
                        <span>{{ enrolment.relation.full_name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {mapGetters} from 'vuex';
    import BModal from "bootstrap-vue/lib/components/modal";
    import { ReaLoader } from '~/components/helpers'

    export default {
        name: 'relation-trajectory-enrolments-modal',

        components: {
            'b-modal': BModal,
            'rea-loader': ReaLoader,
        },

        computed: mapGetters({
            enrolments: 'enrolments',
            isLoading: 'isLoading',
        }),

        methods: {
            onHidden() {
                this.$store.dispatch('clearEnrolments');
            },
        },
    };
</script>

<style>
.relative {
    position: relative;
}

.modal-body {
    min-height: 100px;
    position: relative;
}
</style>
